export type Coin = {
	label: string;
	symbol: string;
};

export type CoinPair = {
	id: string;
	pairs: [first: Coin, second: Coin];
};

export type PoolTokenCategory = "ETH" | "BTC" | "Stablecoin" | "Altcoin";

export const POOL_DISPLAY_ORDER_PRIORITY: readonly PoolTokenCategory[] = [
	"ETH",
	"BTC",
	"Stablecoin",
	"Altcoin",
] as const;

/**
 * Persisted pool pair contract:
 * - `Pool.token1` / `Pool.token2` are normalized display order only.
 * - `Pool.token0Address` / `Pool.token1Address` remain canonical onchain order.
 * - aliases are normalized for ranking only (`ETH -> WETH`, `BTC -> WBTC`).
 * - display ranking prefers ETH-family first, then BTC-family, then stablecoins; Altcoin/Stablecoin pairs use Altcoin first.
 * - same-bucket tie-breakers: normalized symbol, raw symbol, then address.
 */
